import ReportService from "../services/report.service";

// Action to get report from since launched
export const getReportFromSinceLaunched = () => (dispatch) => {
    return ReportService.getReportFromSinceLaunched().then((data) => {
        return Promise.resolve(data);
    }, (error) => {
        return Promise.reject(error);
    });
}